export default "__VITE_ASSET__DYo8lmhq__"